import { supabase } from "@/integrations/supabase/client";

// Helper to bypass strict typing for manually-created feedback tables
const fb = supabase as any;

export function feedbackQuery(table: string) {
  return fb.from(table);
}

// Batch-fetch profiles (+ roles) and attach to items/comments.
export async function attachProfiles(items: any[]): Promise<any[]> {
  const userIds = [...new Set(items.map((i) => i.user_id).filter(Boolean))];
  if (!userIds.length) return items;
  const [{ data: profiles }, { data: roles }] = await Promise.all([
    (supabase as any)
      .from("profiles")
      .select("id, username, first_name, last_name, avatar_url")
      .in("id", userIds),
    (supabase as any)
      .from("user_roles")
      .select("user_id, role")
      .in("user_id", userIds),
  ]);
  const adminIds = new Set(
    (roles ?? [])
      .filter((r: any) => r.role === "admin" || r.role === "team")
      .map((r: any) => r.user_id)
  );
  const profileMap = new Map(
    (profiles ?? []).map((p: any) => [p.id, { ...p, is_team: adminIds.has(p.id) }])
  );
  return items.map((item) => ({ ...item, profiles: profileMap.get(item.user_id) ?? null }));
}

// RPC helper
export function feedbackRpc(fn: string, args: Record<string, any>) {
  return fb.rpc(fn, args);
}

export const feedbackStorage = supabase.storage;

// Client-side notification trigger
// Gathers recipients from DB, then calls edge function with all needed data
export async function triggerNotification(params: {
  feedbackItemId: string;
  notificationType: "new_comment" | "status_change" | "new_item" | "merged";
  actorUserId: string;
  commentBody?: string;
  mergeSourceTitle?: string;
}) {
  try {
    const { data, error } = await (supabase as any).functions.invoke("send-notification-email", {
      body: {
        feedbackItemId: params.feedbackItemId,
        notificationType: params.notificationType,
        actorUserId: params.actorUserId,
        ...(params.commentBody ? { commentBody: params.commentBody } : {}),
        ...(params.mergeSourceTitle ? { mergeSourceTitle: params.mergeSourceTitle } : {}),
      },
    });

    if (error) {
      console.error("📧 Notification invoke error:", error);
      return;
    }

    console.log("📧 Notification invoke result:", data);
  } catch (err) {
    console.error("📧 Notification error:", err);
  }
}
